import { render, staticRenderFns } from "./TrafficSources.vue?vue&type=template&id=a5f48b04&scoped=true"
import script from "./TrafficSources.vue?vue&type=script&lang=js"
export * from "./TrafficSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f48b04",
  null
  
)

export default component.exports